<h2 i18n class="profile-header">User Profile</h2>
<p i18n>We would like to get to know you.</p>
@if (form(); as form) {
  <form [formGroup]="form" (ngSubmit)="updateProfile()">
    <div class="element">
      <label i18n class="label" for="country">Where do you live?</label>
      <select id="country" formControlName="country">
        @for (country of options.countries; track country.id) {
          <option [value]="country.id">{{ country.label }}</option>
        }
      </select>
    </div>
    <div class="element">
      <label i18n class="label" for="yearsInIndustry">
        How many years have you worked in the agriculture industry?
      </label>
      <select id="yearsInIndustry" formControlName="yearsInIndustry">
        @for (yearsInIndustry of options.yearsInIndustry; track yearsInIndustry.id) {
          <option [value]="yearsInIndustry.id">{{ yearsInIndustry.label }}</option>
        }
      </select>
    </div>
    <div class="element">
      <label i18n class="label" for="role">What is your role?</label>
      <select id="role" formControlName="role">
        @for (role of options.roles; track role.id) {
          <option [value]="role.id">{{ role.label }}</option>
        }
      </select>
    </div>
    @if (role() === "farm-owner" || role() === "farm-worker") {
      <div class="element">
        <div i18n class="label">What is the size of your farm?</div>
        <div class="radio-block">
          <span i18n>Show in: </span>
          @for (size of options.sizeUnits; track size.id) {
            <label> <input type="radio" formControlName="sizeUnit" [value]="size.id" /> {{ size.label }}</label>
          }
        </div>
        <select formControlName="farmSize">
          @let farmSizeData = form.get("sizeUnit")?.value === "ha" ? options.farmSizesHectares : options.farmSizesAcres;
          @for (size of farmSizeData; track size.id) {
            <option [value]="size.id">{{ size.label }}</option>
          }
        </select>
      </div>
      <div class="element">
        <label i18n class="label" for="livestock">Does your farm have any livestock?</label>
        <select id="livestock" formControlName="livestock">
          @for (option of options.livestockOptions; track option.id) {
            <option [value]="option.id">{{ option.label }}</option>
          }
        </select>
      </div>
    }
    @if (role() === "contractor-owner" || role() === "contractor-worker") {
      <div class="element">
        <label i18n class="label" for="companySize">What is the size of your company?</label>
        <select id="companySize" formControlName="companySize">
          @for (size of options.companySizes; track size.id) {
            <option [value]="size.id">{{ size.label }}</option>
          }
        </select>
      </div>
    }
    @if (role() === "dealer" || role() === "consultant") {
      <div class="element">
        <label i18n class="label" for="companyName">What is the name of your company?</label>
        <input id="companyName" type="text" formControlName="companyName" />
      </div>
    }
    <app-button i18n type="submit" variant="primary" [disabled]="form.invalid">Save</app-button>
  </form>
}
